module.exports = __webpack_public_path__ + "media/crowd-cheering.0f64f29e.mp3";